<main class="app-layout">
  <router-outlet></router-outlet>
</main>
